import * as React from "react";
import { WizardComponent } from "../../../../Shared/Process/WizardComponent";
import { ActionType } from "../../../../../react-core/Flux/ActionType";
import { Navigator } from "../../../../Shared/Wizards/Entities/Navigator";
import { Urls } from "../../../Urls";
import { Contents } from "../../../Resoures/Contents";
import { Confirmation } from "../../../../Shared/Process/Process/Confirmation";
import { UpdateLifetimeAllowanceStore } from "./Store/Variable";
import { AccountLifetimeAllowanceStore } from "./Store/Variable";
import { getQueryParameters } from "../../../../Shared/Wizards/Entities/QueryParametersHelper";
import { updateLifetimeAllowanceSteppersMap, UpdateLifetimeAllowanceContent } from "./Resource/Content";
import { UpdateLifetimeAllowanceAction } from "./Actions/UpdateLifetimeAllowanceAction";
import { AccountLifetimeAllowanceAction } from "./Actions/AccountLifetimeAllowanceAction";
import { IStepConfig, StepType } from "../../../../Shared/Process/Process/Process";
import { UpdateLifetimeAllowanceDetail } from "./Components/UpdateLifetimeAllowanceDetail";
import { TaxYearHelper } from "../Common/Helpers/TaxYearHelper";
import { PrimaryPclsUsage } from "../../../../../Wrap/Models/Domains/Drawdown/PrimaryPclsUsage";
import { CurrencyCode } from "../../../../../Wrap/Constants/Enums/Domain/CurrencyCode";
import { Action } from "../../../Actions/Action";

export class UpdateLifetimeAllowanceWizard extends WizardComponent {
    constructor(props: any) {
        super(props);
        this.subscribeToStore(UpdateLifetimeAllowanceStore, () => this.onInstructionStoreChange());
        this.subscribeToStore(AccountLifetimeAllowanceStore, () => this.onAccountLifetimeAllowanceStoreChange());
    }

    private onInstructionStoreChange() {
        if (UpdateLifetimeAllowanceStore.getActionType() == ActionType.Success) {
            const data = UpdateLifetimeAllowanceStore.getData();
            this.setState((preState) => ({
                isLoading: false,
                data: data,
                extraInfo: { ...preState.extraInfo, offPlatformData: data },
            }));
        } else if (UpdateLifetimeAllowanceStore.getActionType() == ActionType.Update) {
            this.setState((preState) => ({
                extraInfo: {
                    ...preState.extraInfo,
                    lifetimeAllowanceOffPlatformPercentage: UpdateLifetimeAllowanceStore.getLifetimeAllowanceOffPlatform(),
                },
            }));
        }
    }

    private onAccountLifetimeAllowanceStoreChange() {
        if (AccountLifetimeAllowanceStore.getActionType() == ActionType.Success) {
            const data = AccountLifetimeAllowanceStore.getData();
            this.setState((preState) => ({
                isLoading: false,
                extraInfo: { ...preState.extraInfo, onPlatformData: data },
            }));
        }
    }

    componentDidMount() {
        super.componentDidMount();
        const params = getQueryParameters();
        const subAccountHierarchyId = params["hierarchyid"];
        UpdateLifetimeAllowanceAction.getInstruction(subAccountHierarchyId);

        AccountLifetimeAllowanceAction.getInstruction(subAccountHierarchyId);
    }

    saveInstruction(from, to, toUrl, params, stepLength) {
        if (to == -1) {
            this.onExit();
        } else {
            Navigator.navigateTo(toUrl, {
                queryParamsObject: params,
                scrollAfterNavigating: true,
            });
        }
    }

    onCancel() {
        this.onExit();
    }

    onExit() {
        const params = getQueryParameters();
        Navigator.navigateTo(Urls.get().main.Dashboard, {
            queryParamsObject: {
                hierarchyid: params["hierarchyid"],
            },
            scrollAfterNavigating: true,
        });
    }

    onSubmit() {
        this.setState({ isSubmitting: true, active: false, isShowErrorMsg: false, errorMsg: [] });
        const instruction = this.state.data;
        const taxYear = TaxYearHelper.GetCurrentTaxYear();
        const index = instruction.PrimaryPclsUsages.findIndex((a) => a.Year == taxYear);
        if (index == -1) {
            instruction.PrimaryPclsUsages.push({
                Year: taxYear,
                Amount: {
                    Currency: CurrencyCode.GBP,
                    Amount:
                        instruction.LifeTimeAllowanceValue *
                        this.state.extraInfo.lifetimeAllowanceOffPlatformPercentage,
                },
            });
        } else {
            instruction.PrimaryPclsUsages[index].Amount.Amount =
                instruction.PrimaryPclsUsages[index].Amount.Amount +
                instruction.LifeTimeAllowanceValue * this.state.extraInfo.lifetimeAllowanceOffPlatformPercentage;
        }

        UpdateLifetimeAllowanceAction.submitInstruction(getQueryParameters()["hierarchyid"], instruction, () =>
            this.setState({ isSubmitting: false })
        );
    }

    getStepProps(index) {
        const { active } = this.state;
        const stepProps = super.getStepProps(index);
        stepProps.isReview = !active;
        return stepProps;
    }

    private setReviewConfirmSteppers() {
        const type = Number(getQueryParameters()["type"]);
        const { data } = this.state;
        const clAccountId = getQueryParameters()["claccountid"];
        const len = this.stepperConfig.length;
        return [
            {
                title: updateLifetimeAllowanceSteppersMap.updateLifetimeAllowanceConfirmation,
                url: Urls.get().UpdateLifetimeAllowanceConfirmation,
                path: Contents.URLMap.confirmation,
                type: StepType.Confirmation,
                component: (
                    <Confirmation
                        onExit={() => this.onExit()}
                        successMessage={`We have successfully received your instruction to update the Lifetime allowance for ${data?.ClientDetails?.FirstName} ${data?.ClientDetails?.LastName} (${clAccountId})`}
                        isLoading={this.state.isSubmitting}
                    />
                ),
            },
        ];
    }

    setStepperConfig() {
        const steppers: IStepConfig[] = [
            {
                title: updateLifetimeAllowanceSteppersMap.updateLifetimeAllowanceDetail,
                url: Urls.get().UpdateLifetimeAllowanceDetail,
                path: Contents.URLMap.updateLifetimeAllowanceDetail,
                onSubmit: () => this.onSubmit(),
                onStepLeave: (from, to) => {
                    this.onStepperLeave(from, to);
                },
                component: <UpdateLifetimeAllowanceDetail {...this.getStepProps(0)} extraInfo={this.state.extraInfo} />,
            },
        ];

        this.stepperConfig = steppers;
        this.stepperConfig = this.stepperConfig.concat(this.setReviewConfirmSteppers());
    }

    setProcessProps() {
        Action.getClientAccount(getQueryParameters()["hierarchyid"], (ClientAccountDetails) =>
            this.setClientAccount(ClientAccountDetails)
        );
        const { clientInfo } = this.state;
        const processProps = super.setProcessProps();
        processProps.processTitle = "Update lifetime allowance";
        processProps.needSplitHeader = {
            fromStep: 0,
            splitHeaderMain: `${clientInfo?.clientName}`,
            splitHeaderSub: `${clientInfo?.headAccount}`,
        };
        return processProps;
    }

    setClientAccount(ClientAccountDetails) {
        const accountName = ClientAccountDetails.AccountName;
        const headAccount = ClientAccountDetails.HeadClAccountId;
        this.setState({
            clientInfo: {
                clientName: accountName,
                headAccount: headAccount,
            },
        });
    }
}
